<template>
  <div class="settings">
    <div class="col-12">
      <h3>Notification Settings</h3>
      <Loader v-if="!settings" />
      <notification-settings-form
        v-else
        :on-save="onSave"
        :settings="settings"
      />
    </div>
  </div>
</template>

<script>
import UserClient from '@/api/UserClient';
import NotificationSettingsForm from '@/components/forms/NotificationSettingsForm.vue';
import Loader from '@/components/Loader.vue';

export default {
  name: 'AccountNotifications',
  components: {
    NotificationSettingsForm,
    Loader,
  },
  data() {
    return {
      userClient: new UserClient(this.$http),
      settings: null,
    };
  },
  mounted() {
    this.loadSettings();
  },
  methods: {
    onSave(company, ex) {
      if (company) {
        this.$globals.showSuccess('Settings Saved!');
        this.$globals.scrollToTop();
        this.loadSettings();
      } else if (ex) {
        this.$globals.showError('Settings did not save. Please try again!', ex);
      }
    },

    loadSettings() {
      this.userClient.getNotificationSettings().then(settings => {
        this.settings = settings;
      }).catch(ex => {
        this.$globals.showError('Failed to load settings', ex);
      });
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
